import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { color, size, spacing } = ids || {};
export const StyledDroplistScrollWrapper = styled.div `
  ${({ hasScroll }) => (hasScroll ? `padding-right: 16px` : "")};
`;
export const StyledDroplist = styled.div `
  z-index: ${({ zIndex }) => zIndex};
  display: flex;
  justify-content: start;
  align-items: start;
  width: ${({ hasScroll }) => (hasScroll ? `280px` : `260px`)};
  min-height: 152px;
  height: fit-content;
  max-height: 208px;

  * {
    max-width: 100%;
  }

  position: absolute;
  top: ${spacing.ids_spacing_2x};
  ${({ position }) => {
    if (position === "left")
        return `right: auto; left: 0;`;
    return `right: 0; left: auto;`;
}}
  overflow: hidden;

  background: ${color.backgrounds.ids_color_bg_base};
  border-radius: ${size.general.ids_size_general_12x};
  border: ${size.border_width.ids_size_border_small} solid
    ${color.border.ids_color_border_soft};

  padding-block: ${size.general.ids_size_general_8x};
  padding-inline: ${size.general.ids_size_general_16x};

  > div {
    overflow-y: auto;
    max-height: 208px;
    width: 100%;

    ::-webkit-scrollbar {
      width: 4px;
    }
    ::-webkit-scrollbar-track {
      background-color: ${color.action.disabled.ids_color_action_disabled_base};
      border-radius: ${size.general.ids_size_general_12x};
      padding-right: 16px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${color.action.disabled
    .ids_color_action_disabled_variant};
      border-radius: ${size.general.ids_size_general_12x};
    }
    ::-webkit-scrollbar-corner,
    ::-webkit-scrollbar-button {
      background-color: transparent;
      width: 16px;
      height: 8px;
    }

    ::-webkit-scrollbar-thumb:vertical {
      margin-right: 16px;
    }
  }
`;
//# sourceMappingURL=MenuDroplist.style.js.map